// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__--ukk","spin":"Loader_spin__xgsp5","sm":"Loader_sm__qpFhQ","md":"Loader_md__lCQ2q","lg":"Loader_lg__WgULJ"};